export default "e62dacada7d62ed0.svg"